module.exports = __webpack_public_path__ + "img/qy (22).1e1297cb.jpg";